<template>
  <div class="page-add">
    <div class="add-title">新增考试</div>
    <class-exam
      v-if="examType == 0"
      :examTypeData="examTypeData"
      :publicData="publicData"
      @changeExamType="changeExamType"
      ref="classExam"
    ></class-exam>
    <!--删除课件-->
    <!--<courseware-exam
      v-if="examType == 1"
      :examTypeData="examTypeData"
      :publicData="publicData"
      @changeExamType="changeExamType"
      ref="coursewareExam"
    ></courseware-exam>-->
    <directional-exam
      v-if="examType == 2"
      :examTypeData="examTypeData"
      :publicData="publicData"
      @changeExamType="changeExamType"
      ref="directionalExam"
    ></directional-exam>
    <div class="handle">
      <el-button size="small" @click="resetForm">重置</el-button>
      <el-button size="small" @click="goBack">返回</el-button>
      <el-button size="small" type="primary" @click="submit">提交</el-button>
    </div>
  </div>
</template>

<script>
import ClassExam from "./classExam";
// import CoursewareExam from "./coursewareExam";
import DirectionalExam from "./directionalExam";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
export default {
  components: {
    ClassExam,
    // CoursewareExam,
    DirectionalExam,
  },
  data() {
    return {
      examType: "0",
      examTypeData: [],
      publicData: []
    };
  },
  created() {
    this.getSysParamByTypes(["EXAM_INFO_TYPE", "IS_VALID"]);
  },
  methods: {
    goBack() {
      this.$router.push('/examInfo');
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.examTypeData = res.data["EXAM_INFO_TYPE"].sort(function(a, b) {
          return parseInt(a.paramKey) - parseInt(b.paramKey);
        }).map(ele => {
          ele.paramKey = parseInt(ele.paramKey);
          return ele;
        });
        this.publicData = res.data["IS_VALID"].sort(function(a, b) {
          return parseInt(a.paramKey) - parseInt(b.paramKey);
        }).map(ele => {
          ele.paramKey = parseInt(ele.paramKey);
          return ele;
        });
      });
    },
    changeExamType(e) {
      this.examType = e;
    },
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        if (this.examType == 0) {
          this.$refs["classExam"].reset();
        } else if (this.examType == 1) {
          this.$refs["coursewareExam"].reset();
        } else if (this.examType == 2) {
          this.$refs["directionalExam"].reset();
        }
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    submit() {
      if (this.examType == 0) {
        this.$refs["classExam"].submit();
      } else if (this.examType == 1) {
        this.$refs["coursewareExam"].submit();
      } else if (this.examType == 2) {
        this.$refs["directionalExam"].submit();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.handle {
  margin-top: 30px;
  text-align: center;
}
</style>
